<page-headline
    [linkTitle]="'Performance'"
    [module]="'performance'"
    [moduleIcon]="'fa-heartbeat'"
    [moduleLink]="'performance'"
    [pageTitle]="'Key Performance Indicators'"
>
</page-headline>
<div class="white-background-with-box-shadow">
    <div class="kpi-view-search-and-title-area">
        <div class="heading-area">
            Target and performance ranges for active KPIs
            <span class="kpi-export-button-area">
                <span (click)="exportData()" title="Download Excel" class="kpi-export-button">
                    <mat-icon fontSet="fas" fontIcon="fa-file-excel"></mat-icon>
                </span>
            </span>
        </div>
        <div class="kpi-search-area">
            <search-dialog
                (searchOutput)="searchRows($event)"
                [searchId]="'kpi-view-search'"
                [showSearchBox]="true"
                [searchBoxHeight]="44"
                [resetSearch]="searchTerm === '' || searchTerm === null"
            >
            </search-dialog>
        </div>
    </div>
    <div class="app-performance-kpi-table">
        <common-kendo-table
            [tableColumnProperties]="kpiTableColumnProperties"
            [tableDataProperties]="kpiTableDataProperties"
        >
        </common-kendo-table>
    </div>
</div>
